import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const RadioSquareUnselect = ({
  size = 16,
  title = 'Unselect',
  fill = colors.silverSandAlt,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 25.63 25.629">
      {Boolean(title) && <title>{title}</title>}
      <g transform="translate(-300.908 -288.973)">
        <path
          d={`
M322.413,314.6h-17.38a4.13,4.13,0,0,1-4.125-4.125V293.1a4.13,4.13,0,0,1,
4.125-4.125h17.38a4.13,4.13,0,0,1,4.125,4.125v17.379A4.13,4.13,0,0,1,
322.413,314.6Zm-17.38-23.379a1.878,1.878,0,0,0-1.875,1.875v17.379a1.878,
1.878,0,0,0,1.875,1.875h17.38a1.878,1.878,0,0,0,1.875-1.875V293.1a1.878,1.878,0,0,0-1.875-1.875Z
`}
          fill={fill}
        />
      </g>
    </svg>
  );
};
